import { combineReducers } from "redux";

import user from "./user";
import routesData from "./routes";
import loader from "./loader";
import route from "./route";
import notifications from "./notifications";
import schedule from "./schedule";
import app from "./app";
import ui from "./ui";
import modal from "./modal";
import sectionsData from "./sections";

export default combineReducers({
  app,
  user,
  routesData,
  loader,
  route,
  notifications,
  schedule,
  ui,
  modal,
  sectionsData,
});
